const HTTPRequest = {
  authToken: "",
  getJson: function (url, isRelativeUrl, afterResponse) {
    var reqUrl = isRelativeUrl ? new URL(url, document.baseURI).href : url;

    var xhr = new XMLHttpRequest();

    xhr.open("GET", reqUrl);
    // xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
    //  xhr.setRequestHeader("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");

    if (this.authToken) {
      xhr.setRequestHeader("x-auth-token", this.authToken);
    }

    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          JSON.parse(xhr.responseText);
        } catch (e) {
          afterResponse(xhr.responseText);
        }
        afterResponse(JSON.parse(xhr.responseText));
      } else {
        // window.location.href = process.env.REACT_APP_BASE_URL + "/404";
        afterResponse(null);
      }
    };
    xhr.send();
  },

  appendQueryStringToCurrentUrl(queryString) {
    let fullurl = document.location.href + queryString;
    return fullurl;
  },
  executeApi: function (url, afterResponse) {
    this.getJson(url, false, afterResponse);
  },

  postData: function (url, jsonInput, afterResponse) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onload = function () {
      if (xhr.status === 200) {
        afterResponse(xhr.responseText);
      } else {
        afterResponse(null);
      }
    };
    xhr.send("jsonInput=" + JSON.stringify(jsonInput));
  },
};

export default HTTPRequest;
